import React from 'react';

import { MAIN_THEME } from '@styles';

import FormFieldWrapper from './FormFieldWrapper';
import { IFormFieldInputBaseProps } from '.';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

export interface ITextAreaFormFieldProps extends IFormFieldInputBaseProps {
  rows?: number;
  value: string | number;
  draggable?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const useStyles = makeStyles()(() => ({
  labelWrapper: {
    display: 'block',
    textAlign: 'left',
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '15px'
  },
  label: {
    display: 'block',
    color: MAIN_THEME.color.black,
    textAlign: 'left',
    fontFamily: MAIN_THEME.font.regular
  },
  input: {
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '15px',
    width: '100%',
    padding: '10px 15px 5px 15px',
    margin: '0 auto',
    backgroundColor: MAIN_THEME.color.white98,
    border: `1px solid ${MAIN_THEME.color.white86}`,
    boxSizing: 'border-box',
    borderRadius: '5px',
    fontFamily: MAIN_THEME.font.regular,
    resize: 'none',
    '&:focus-visible': {
      outline: 'none'
    },
    '&::placeholder': {
      color: 'rgba(0, 0, 0, 0.20)',
      fontStyle: 'italic'
    }
  },
  inputError: {
    borderColor: MAIN_THEME.color.red,
    outlineColor: MAIN_THEME.color.red,
    fontFamily: MAIN_THEME.font.regular
  }
}));

const TextAreaFormField: React.FC<ITextAreaFormFieldProps> = ({
  rows = 6,
  error,
  name,
  disabled,
  placeholder,
  title,
  value,
  draggable = true,
  onChange,
  onBlur
}) => {
  const { classes } = useStyles();

  return (
    <FormFieldWrapper title={title} error={error} name={name}>
      <textarea
        className={clsx(classes.input, {
          [classes.inputError]: error
        })}
        rows={rows}
        title={title}
        id={name}
        name={name}
        aria-invalid={!!error}
        aria-describedby={`errorMsg-${name}`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        draggable={draggable}
        disabled={disabled}
        placeholder={placeholder}
      />
    </FormFieldWrapper>
  );
};

export default TextAreaFormField;
